import VueApp from "../../03-fragments/vueApp/VueApp.js";

const processor = function(data) {
    return data;
}

VueApp.init({
    id: "blogPage",
    processor: processor,
    settings: {
        customType: "blog-story",
        root: "/fortschritt",
    },
    data: {
    },
});
